import React from 'react'
import PropTypes from 'prop-types'
import './CtiLinkCompound.css'

const Icon = ({ type, children }) => {
  return (
    <div>
      <span className="Icon--material u-textSizeMsrp1">{type}</span>
      {children}
    </div>
  )
}
Icon.propTypes = {
  type: PropTypes.string,
  children: PropTypes.object,
}

const CtiLinkCompound = (props) => {
  const { text, asButton, buttonClasses, target, link, icon, classNames } =
    props
  const linkHref = link[0]?.linkHref
  const buttonClassList = asButton
    ? `Button Button--secondary u-textUppercase ${buttonClasses} u-paddingLeft4gu u-paddingRight4gu`
    : ''

  const content = icon ? (
    <Icon type={icon}>
      <span className="u-paddingLeft1gu u-textSizeMsrm1">{text}</span>
    </Icon>
  ) : (
    text
  )

  return linkHref && text ? (
    <div className={`CtiLinkCompound ${classNames || ''}`}>
      {linkHref && text && (
        <div className="u-flex u-flexAlignItemsCenter u-marginTop2gu">
          <a
            href={linkHref}
            className={`u-flex u-flexAlignItemsCenter Link ${buttonClassList}`}
            target={target || '_blank'}
            rel="noreferrer"
          >
            {text && content}
          </a>
        </div>
      )}
    </div>
  ) : null
}
CtiLinkCompound.propTypes = {
  name: PropTypes.string,
  displayName: PropTypes.string,
  icon: PropTypes.string,
  description: PropTypes.string,
  text: PropTypes.string,
  asButton: PropTypes.bool,
  buttonClasses: PropTypes.string,
  target: PropTypes.string,
  link: PropTypes.arrayOf(
    PropTypes.shape({
      $ref: PropTypes.string,
      linkHref: PropTypes.string, // processed from pageAPI when component receives page prop
    })
  ),
  classNames: PropTypes.string,
  contentType: PropTypes.string,
}
export { CtiLinkCompound }
